import { useIntl } from 'react-intl';

import { IItemOption, INutritionInfo } from '@rbi-ctg/menu';
import { MenuObjectTypes } from 'enums/menu';

import {
  IItemOptionModifierNutritionInfo,
  IUseModifierNutritionFactsProps,
  NutritionFacts,
} from './types';
import { emptyNutritionFacts, getAllergenGroups } from './utils';

type UseNutritionFacts = (props: IUseModifierNutritionFactsProps) => NutritionFacts[];

export const useNutritionModifierFacts: UseNutritionFacts = ({
  pickerSelection,
  selectedOption,
}) => {
  const { formatMessage } = useIntl();
  const nutritionFacts = [] as NutritionFacts[];

  const nutritionKeys = Object.keys(emptyNutritionFacts) as (keyof INutritionInfo)[];
  const getItemOptionModifierNutrition = (
    modifier: IItemOption | IItemOptionModifierNutritionInfo
  ) => {
    if ('nutrition' in modifier) {
      if (Object.keys(modifier?.nutrition)?.length) {
        const map = { ...emptyNutritionFacts };
        nutritionKeys.forEach(
          nutritionKey => (map[nutritionKey] += modifier?.nutrition?.[nutritionKey] ?? 0)
        );
        nutritionFacts.push({
          itemName: modifier?.name.locale,
          itemImage: modifier?.image,
          facts: map,
          //@ts-ignore
          allergenGroups: modifier?.allergen
            ? //@ts-ignore
              getAllergenGroups(modifier?.allergen, formatMessage)
            : [],
        });
      }
    }
  };

  if (pickerSelection._type === MenuObjectTypes.ITEM_OPTION_MODIFIER) {
    //@ts-ignore
    getItemOptionModifierNutrition(pickerSelection);
  } else if (
    pickerSelection._type === MenuObjectTypes.ITEM_OPTION &&
    selectedOption !== undefined
  ) {
    //@ts-ignore
    getItemOptionModifierNutrition(selectedOption);
  }

  return nutritionFacts;
};
